<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template>

        <t-input v-model="form.typePathologyId" hidden/>

        <b-row>

          <t-input v-model="form.name" cols="9" :add-error="error.name" label="Tipo de Anomalia" required/>

          <t-input v-model="form.typePathologyCodeLabel"
                   v-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_MANUAL"
                   :add-error="error.typePathologyCodeLabel" upper cols="3"
                   label="Cód. Anomalia"
                   help="Código inserido manualmente conforme configurado em Checklists > Configurações > Parâmetros"
                   required/>

          <t-input v-model="form.typePathologyCodeLabel"
                   v-else-if="modeCodeLabel === SettingType.mode.MODE_CODE_LABEL_AUTOMATIC_DEFAULT"
                   :add-error="error.typePathologyCodeLabel" upper cols="3"
                   fixed
                   label="Cód. Anomalia"
                   help="Código inserido automaticamente conforme configurado em Checklists > Configurações > Parâmetros"
          />

        </b-row>

        <t-input v-model="form.sectorId"
                 :options="sectorOptions"
                 :add-error="error.sectorId"
                 label="Categoria relacionada" required select/>

        <!-- <t-input v-model="form.color" color-reduced label="Cor" />-->

        <t-input v-model="form.defaultTypeAnomalyOrigin" radio :options="AnomalyOriginType.list"
                 help="Especifique caso desejar pré-selecionar uma origem padrão)."
                 label="Origem (padrão)"/>

        <t-msg info v-if="anomalyOriginHelp">
          <b>Orientação por tipo de origem:</b><br />{{ anomalyOriginHelp }}
        </t-msg>

        <t-input class="mt-2" v-model="form.unit" radio :options="UnitType.list"
                 help="Especifique caso desejar pré-selecionar uma unidade de medida padrão em relação a este anomalia para novos apontamentos (terá prioridade sobre uma possível unidade de medida do item)."
                 label="Un. Medida"/>

        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

        <t-input-status v-model="form.status"/>

      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import SectorService from "@/services/modules/agent/Sector.service";
import SettingType from "@/model/types/resource/SettingType";
import UnitType from "@/model/types/modules/general/UnitType";
import AnomalyOriginType from "@/model/types/modules/checklist/AnomalyOriginType";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'TypePathologyForm',
  data() {
    return {
      AnomalyOriginType,
      UnitType,
      SettingType,
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: false,
      fieldKey: "typePathologyId",
      form: {
        typePathologyId: 0,
        typePathologyNumber: 0,
        typePathologyCodeLabel: "",
        defaultTypeAnomalyOrigin: AnomalyOriginType.type.UNDETERMINED,
        name: "",
        sectorId: "",
        color: "",
        note: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        typePathologyCodeLabel: "",
        name: "",
        sectorId: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      modeCodeLabel: "",
      sectorOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      this.modeCodeLabel = this.getRenderRule(SettingType.render.RENDER_TAG_COD_LABEL)

      await SectorService.selectList().then((list) => {
        this.sectorOptions = list
      }).catch(error => this.responseError(error))

      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },
  computed: {
    anomalyOriginHelp() {

      const item = AnomalyOriginType.list.find(
          i => i.value === this.form.defaultTypeAnomalyOrigin
      );

      return item ? item.help : null;
    }
  }

}
</script>

